import React, { Component } from 'react'
import axios from 'axios';
import { withTranslation} from 'react-i18next';
import SystemHeader from './SystemHeader';
import UserDropdown from './components/UserDropdown';

import moment from "moment";
import 'moment/locale/is';
import { decrypt } from '../../helpers/decrypt'

import { getToken, removeAdminSession, getSession, getRefreshToken,setRefreshUserSession } from  '../../../Utils/admincommon'
const token = getToken();
const refreshtoken = getRefreshToken();
const session = getSession();

document.body.classList.add("admin");

export class IGExpertView extends Component {

    state = {
        posts: [],
        isLoaded: false,
        checked:false,
        perpage: 0,
        createdon: "",
        q1:0,
        q2:0,
        q3:0,
        q4:0,
        q5:0,
        q6:0,
        q7:0,
        q8:0,
        q9:0,
        q10:0,
        q11:0,
        q12:0,
        score:1,
        name:"",
        whatsyklalyf:"",
        aukaverkanir:"",
        einkenni:"",
        userid: this.props.match.params.id
    }

    componentDidMount () {
        var config = {
            'Authorization': token,
            'Content-Type': 'application/json'
        }

        var selectedUser = "";

        if(this.props.match.params.id !== undefined) {
            selectedUser = this.props.match.params.id;
        }

        axios.get(global.config.api.url.live + '/igeview/'+selectedUser, {
            param: {
                per_page: 2
            },
            headers: config
        })
        .then(res => this.setState({
            posts: res.data.data.ige,
            q1: res.data.data.ige[0].q1,
            q2: res.data.data.ige[0].q2,
            q3: res.data.data.ige[0].q3,
            q4: res.data.data.ige[0].q4,
            q5: res.data.data.ige[0].q5,
            q6: res.data.data.ige[0].q6,
            q7: res.data.data.ige[0].q7,
            q8: res.data.data.ige[0].q8,
            q9: res.data.data.ige[0].q9,
            q10: res.data.data.ige[0].q10,
            q11: res.data.data.ige[0].q11,
            q12: res.data.data.ige[0].q12,
            name: res.data.data.ige[0].name,
            createdon: res.data.data.ige[0].createdon,
            whatsyklalyf: res.data.data.ige[0].syklalif,
            aukaverkanir: res.data.data.ige[0].aukaverkanir,
            einkenni: res.data.data.ige[0].einkenni,
            score: res.data.data.ige[0].score,
            isLoaded: true,
            perpage: res.data.data.per_page
        }))
        .catch(error => {
			const response = error.response;
            if (response.status === 403) {
                const json = JSON.stringify({ refresh_token: refreshtoken });
                axios.patch(global.config.api.url.live + '/adminsessions/'+session, json , {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json'
                    }
                }, { crossdomain: true })
                .then(response => {
                    setRefreshUserSession(response.data.data.access_token, response.data.data.refresh_token);
                    window.location.reload();
                })
                .catch(error => {
                    const response = error.response;
                    console.log(response);
                })
            } else {
                removeAdminSession();
                window.location.reload();
            }
        })
    }

    render() {
        const { t } = this.props;
        const { posts, isLoaded, q1, q2, q3, q4, q5, q6, q7, q8, q9, q10, q11, q12, whatsyklalyf,name, einkenni,createdon, userid,score} = this.state;
        if (isLoaded) {
            if (posts) {
                console.log(posts);
                return (
                    <div>
                        <SystemHeader title="IgXpert virknimat"/>
                        <main>
                        <div className='greiningarprof'>
                                <h1>Skoða mat á mótefnameðferð</h1> 
                                <p className='lysing'><strong>{decrypt(name)}</strong><br/>Tekið þann: {moment(createdon).format('Do MMM YYYY')}<br/>Mat: {getlinktext(score)}</p>
                                <br/>
                                <div className='issyklalyfquestion'>
                                    <h3 className="questions">Fyrirbyggjandi sýklalyf?</h3>
                                    <div className='syklalyfquestion'>
                                    </div>
                                    <div className={'issyklalyf istrue'}><h3 className="questions ans">{whatsyklalyf}</h3></div>
                                </div>
                                <h3 className="questions">Fjöldi eyrna-, ennis - eða kinnholusýkinga</h3>
                                <div className={"spurningar_checkboxes q1val" + q1}>
                                    <div className="for-checkbox-tools q1_0"><i className="fa-regular fa-face-smile"></i> <div>0 til 1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q1_1"><i className="fa-regular fa-face-frown-slight"></i> <div>2 til 3<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q1_2"><i className="fa-regular fa-face-confounded"></i> <div>4<br/> sinnum eða oftar</div></div>
                                </div>

                                <h3 className="questions">Fjöldi barka-/berkjubólgna meðhöndlaðar með sýklalyfjum</h3>
                                <div className={"spurningar_checkboxes q2val" + q2}>
                                    <div className="for-checkbox-tools q2_0"><i className="fa-regular fa-face-smile"></i> <div>0 til 1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q2_1"><i className="fa-regular fa-face-frown-slight"></i> <div>2<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q2_2"><i className="fa-regular fa-face-confounded"></i> <div>3<br/> sinnum eða oftar</div></div>
                                </div>
                                
                                <h3 className="questions">Fjöldi lungnabólgna</h3>
                                <div className={"spurningar_checkboxes q3val" + q3}>
                                    <div className="for-checkbox-tools q3_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q3_2"><i className="fa-regular fa-face-frown-slight"></i> <div>1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q3_3"><i className="fa-regular fa-face-confounded"></i> <div>2<br/> sinnum eða oftar</div></div>
                                </div>
                                <h3 className="questions">Fjöldi húðsýkinga</h3>
                                <div className={"spurningar_checkboxes q4val" + q4}>
                                    <div className="for-checkbox-tools q4_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q4_1"><i className="fa-regular fa-face-frown-slight"></i> <div>1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q4_2"><i className="fa-regular fa-face-confounded"></i> <div>2<br/> sinnum eða oftar</div></div>
                                </div>

                                <h3 className="questions">Fjöldi herpessýkinga <small>(t.d. frunsur)</small></h3>
                                <div className={"spurningar_checkboxes q5val" + q5}>
                                    <div className="for-checkbox-tools q5_0"><i className="fa-regular fa-face-smile"></i> <div>0 til 1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q5_1"><i className="fa-regular fa-face-frown-slight"></i> <div>2 til 3<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q5_2"><i className="fa-regular fa-face-confounded"></i> <div>4<br/> sinnum eða oftar</div></div>
                                </div>

                                <h3 className="questions">Fjöldi ígerða (abcessa) sem þurfti að hleypa út</h3>
                                <div className={"spurningar_checkboxes q6val" + q6}>
                                    <div className="for-checkbox-tools q6_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q6_1"><i className="fa-regular fa-face-frown-slight"></i> <div>1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q6_2"><i className="fa-regular fa-face-confounded"></i> <div>2<br/> sinnum eða oftar</div></div>
                                </div>
                                <h3 className="questions">Fjöldi sveppasýkinga <small>(t.d. í húð eða kynfærum)</small></h3>
                                <div className={"spurningar_checkboxes q7val" + q7}>
                                    <div className="for-checkbox-tools q7_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q7_1"><i className="fa-regular fa-face-frown-slight"></i> <div>1 til 2<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q7_2"><i className="fa-regular fa-face-confounded"></i> <div>3<br/> sinnum eða oftar</div></div>
                                </div>
                                
                                <h3 className="questions">Fjöldi tannholdssýkinga</h3>
                                <div className={"spurningar_checkboxes q8val" + q8}>
                                    <div className="for-checkbox-tools q8_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q8_1"><i className="fa-regular fa-face-frown-slight"></i> <div>1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q8_2"><i className="fa-regular fa-face-confounded"></i> <div>2<br/> sinnum eða oftar</div></div>
                                </div>
                                <h3 className="questions">Hve oft niðurgangur og/eða blóð í hægðum</h3>
                                <div className={"spurningar_checkboxes q9val" + q9}>
                                    <div className="for-checkbox-tools q9_0"><i className="fa-regular fa-face-smile"></i> <div>0 til 1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q9_1"><i className="fa-regular fa-face-frown-slight"></i> <div>2 til 3<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q9_2"><i className="fa-regular fa-face-confounded"></i> <div>4<br/> sinnum eða oftar</div></div>
                                </div>
                                <h3 className="questions">Fjöldi sýkinga í heila, liðum eða beini</h3>
                                <div className={"spurningar_checkboxes q10val" + q10}>
                                    <div className="for-checkbox-tools q10_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q10_3"><i className="fa-regular fa-face-confounded"></i> <div>1<br/> sinni eða oftar</div></div>
                                </div>
                                
                                <h3 className="questions">Hve oft sýklalyf í æð eða innlögn á spítala</h3>
                                <div className={"spurningar_checkboxes q11val" + q11}>
                                    <div className="for-checkbox-tools q11_0"><i className="fa-regular fa-face-smile"></i> <div>0<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q11_2"><i className="fa-regular fa-face-frown-slight"></i> <div>1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q11_3"><i className="fa-regular fa-face-confounded"></i> <div>2<br/> sinnum eða oftar</div></div>
                                </div>
                                <h3 className="questions">Fjöldi sýklalyfjakúra</h3>
                                <div className={"spurningar_checkboxes q12val" + q12}>
                                    <div className="for-checkbox-tools q12_0"><i className="fa-regular fa-face-smile"></i> <div>0 til 1<br/> sinni</div></div>
                                    <div className="for-checkbox-tools q12_1"><i className="fa-regular fa-face-frown-slight"></i> <div>2 til 3<br/> sinnum</div></div>
                                    <div className="for-checkbox-tools q12_2"><i className="fa-regular fa-face-confounded"></i> <div>4<br/> sinnum eða oftar</div></div>
                                </div>
                                <h3 className="questions">Önnur einkenni<br/><small>(t.d. aukaverkanir af meðferð)</small></h3>
                                <p>{einkenni}</p>
                            </div>
                        </main>
                    </div>
                )
            } else {
                return (
                    <div>
                        <SystemHeader title="IgXpert virknimat"/>
                        <main>
                            <UserDropdown url="igexpert" selected={userid} />
                            <div className="urgencies listinn">
                                <table className='qualityoflife'>
                                    <thead>
                                        <tr>
                                            <th className='tl'>{t('total_score')}</th>
                                            <th>{t('date')}</th>
                                            <th>Sjúklingur</th>
                                            <th className='tl'>Fyrirbyggjandi sýklalyf?</th>
                                            <th className='tl'>Einkenni</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan="5">Engin innsend gögn.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </main>
                    </div>
                )
            }
        } else {
            return (
                <div></div>
            )
        }
    }
}

function getlinktext(heildarskor,) {
    let heildarskorText = "";
    if (heildarskor >= 3) {
        heildarskorText = 'Alvarlegt';
    } else if (heildarskor === 2) {
        heildarskorText = 'Vægt';
    } else if (heildarskor <= 1) {
        heildarskorText = 'Eðlilegt';
    }
    return heildarskorText;
}

export default withTranslation()(IGExpertView);